module.exports = __webpack_public_path__ + "img/12-detail.daf92416.png";